<h6 *ngIf="sessionService.isLogin; else emptyContentNotLoggedIn" translate>
  FILTERING_LISTING_EMPTY_MESSAGE
</h6>
<ng-template #emptyContentNotLoggedIn>
  <h6 translate>MESSAGE_LIST_NOT_LOGIN</h6>
</ng-template>
